export default __webpack_public_path__ + "static/media/linkdin.0a414e29.svg";